export default __webpack_public_path__ + "static/media/userBlue.0713f134.svg";